<template :style="dynamicStyle">
  <!-- <Mainmenu /> -->

  <template v-if="stage == 'login'">
    <setup @forgotpass="forgotPass" :emailadd="this.email" @login="emailOk" />
  </template>

  <template v-if="stage == 'hint'">
    <hint :emailadd="this.email" @gotoLogin="backToLogin" />
  </template>

  <template v-if="stage == 'email'">
    <email :emailadd="this.email" @gotoLogin="backToLogin" />
  </template>
</template>

<script>


import axios from 'axios'
import setup from './components/setup.vue'
import Mainmenu from './components/menu.vue'
import hint from './components/hint.vue'
import email from './components/email.vue'


export default {
  name: 'App',
  components: {
    setup,
    Mainmenu,
    hint,
    email

  },
  created() {
    document.title = "xcapism Learning Mail";
  },
  data() {
    return {
      stage: "login",
      email: ""

    }
  },
  async mounted() {

    if (localStorage.getItem('emailOK') === "true") {
      this.stage = "email"
    }

  },
  methods: {
    setLanguage(value) {
      console.log
    },
    backToLogin(value) {
      this.email = value;
      this.stage = "login"
    },
    forgotPass(value) {
      this.email = value;
      this.stage = "hint"
    },
    emailOk() {
      this.stage = "email"
    }

  }
}
</script>

<style>
@import './assets//styles.css';
</style>



